export default __webpack_public_path__ + "static/media/host_memo.7ac02102.svg";